// extracted by mini-css-extract-plugin
export default {"feed":"social-follow-feed-FollowerFolloweeFeed__feed--31QNY"};